import React, {useCallback, useLayoutEffect, useMemo} from "react";
import PriceMatricesListView from "./list";
import {Col} from "reactstrap";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Tab, Tabs} from "../../../../components/base/Tabs";
import PriceMatricesManagementViewExceptionalCustomersView from "./exceptional-customers";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {useHistory, useLocation} from "react-router-dom";


const tabs = {
    list: 'list',
    exceptionalCustomers: 'exceptionalCustomers',
};

const defaultTab = tabs.list;


/**
 * The available Actions for the price matrices exceptional entities section.
 */
export const PriceMatricesManagementExceptionalEntitiesDataGridActionNames = {
    Delete: 'delete'
}

const PriceMatricesManagementView = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();


    const tabsList = useMemo(() => {
        return [
            {
                title: "List",
                value: tabs.list,
            },
            ...(operatorAccessLevels.packages.sales.customerPriceMatrices ? [
                {
                    title: "Exceptional Customers",
                    value: tabs.exceptionalCustomers,
                },
            ] : []),
        ]
    }, [operatorAccessLevels.packages.sales.customerPriceMatrices]);

    /**
     * With each change in the [location.pathname] value:
     * - if the route is [priceMatrices.base], then navigates the user to the list view of price matrices.
     */
    useLayoutEffect(() => {
        if (matchPath(location.pathname, {path: routes.settings.priceMatrix.base, exact: true})) {
            return history.replace(routes.settings.priceMatrix.list);
        }
        if (matchPath(location.pathname, {path: routes.settings.priceMatrix.customers, exact: true})) {
            if (!operatorAccessLevels.packages.sales.customerPriceMatrices) {
                return history.replace(routes.settings.priceMatrix.list);
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.sales.customerPriceMatrices])

    const tab = useMemo(() => {
        if (matchPath(location.pathname, {path: routes.settings.priceMatrix.list, exact: true})) {
            return tabs.list;
        }
        if (matchPath(location.pathname, {path: routes.settings.priceMatrix.customers, exact: true})) {
            return tabs.exceptionalCustomers;
        }
        return defaultTab;
    }, [location.pathname])

    /**
     * Changes url associated with the [newTab] value when the user clicks on a new tab in the UI.
     * @type {(function(*, *): (undefined|void))}
     */
    const onTabChanged = useCallback((e, newTab) => {
        if (tab === newTab)
            return;
        switch (newTab) {
            case tabs.list:
                return history.push(routes.settings.priceMatrix.list)
            case tabs.exceptionalCustomers:
                return history.push(routes.settings.priceMatrix.customers)
            default:
                return;
        }
    }, [history, tab])

    /**@type {ReactNode}*/
    const content = useMemo(() => {
        switch (tab) {
            case tabs.list:
                return <PriceMatricesListView/>
            case tabs.exceptionalCustomers:
                return <PriceMatricesManagementViewExceptionalCustomersView/>;
            default:
                return null;
        }
    }, [tab])

    return (
        <>
            <div className={'d-flex flex-wrap w-100'}>
                {
                    operatorAccessLevels.packages.sales.customerPriceMatrices &&
                    <Col xs={12}>
                        <p className={'text-lg font-weight-semi-bold'}>
                            System Tier Pricing Management
                        </p>
                    </Col>
                }
                {
                    operatorAccessLevels.packages.sales.customerPriceMatrices &&
                    <Col xs={12}>
                        <Tabs className={'my-4'} value={tab} onChange={onTabChanged}>
                            {
                                tabsList?.map((tab) => (
                                    <Tab
                                        key={tab.value}
                                        value={tab.value}
                                        label={tab.title}
                                    />
                                ))
                            }
                        </Tabs>
                    </Col>
                }
                <Col xs={12}>
                    {content}
                </Col>
            </div>
        </>
    )
}

export default PriceMatricesManagementView;
